export default "__VITE_ASSET__a4128131__"